/**
 * Profile field helpers derived from GET /me.
 *
 * Profile fields persist via PATCH /me — this module only parses server values
 * into form-friendly shapes (no sessionStorage draft).
 */

import type { CountryCode } from 'libphonenumber-js';
import { parsePhoneNumberFromString } from 'libphonenumber-js';

import { DEFAULT_PHONE_COUNTRY, resolvePhoneCountry } from './phoneCountries';

/** Split a stored E.164 into dial-country + national digits for the form. */
export function splitPhoneE164(e164?: string | null): {
  phone_country: CountryCode;
  phone_national: string;
} {
  if (!e164?.trim()) {
    return { phone_country: DEFAULT_PHONE_COUNTRY.iso2, phone_national: '' };
  }
  const parsed = parsePhoneNumberFromString(e164.trim());
  if (!parsed?.isValid()) {
    return { phone_country: DEFAULT_PHONE_COUNTRY.iso2, phone_national: '' };
  }
  return {
    phone_country: resolvePhoneCountry(parsed.country),
    phone_national: parsed.nationalNumber,
  };
}
